export const TEXTS = {
  MANIFESTS: {
    NAME: "Manifests",
    APP_ID_COL_HEADER: "Application ID",
    CREATE_MANIFEST_BUTTON_LABEL: "Create new manifest",
    CREATION_DATE_COL_HEADER: "Creation date",
    HEADER: "Manifests",
    MOD_DATE_COL_HEADER: "Last edited",
    TARGET_COL_HEADER: "Target",
  },
};
